import * as z$1 from "zod/v4";
//#region src/schemas/agent-controller-collaboration-mode.ts
const agentControllerCollaborationModeSchema = z$1.enum(["codex:default", "codex:plan"]);
//#endregion
export { agentControllerCollaborationModeSchema };

//# sourceMappingURL=agent-controller-collaboration-mode.js.map